<p-dialog
  header="Refunds – Deposit {{ deposit.id }}"
  [(visible)]="visible"
  [modal]="true"
  appendTo="body"
  [style]="{ width: '45%' }"
  (onHide)="close()"
>
  <p-table
    [value]="deposit.refunds"
    responsiveLayout="scroll"
    class="p-datatable-sm"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Active</th>
        <th>Amount</th>
        <th>Date</th>
        <th>Reason</th>
        <th style="width: 10rem">Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-r let-i="rowIndex">
      <tr>
        <td>
          <p-toggleswitch
            [(ngModel)]="r.active"
            (ngModelChange)="toggleActive(r)"
          />
        </td>
        <td>{{ r.jsAmount | currency }}</td>
        <td>{{ r.jsEffectiveDate |  date: "yyyy-MM-dd" }}</td>
        <td>{{ r.metadata?.reason || "-" }}</td>
        <td class="text-nowrap">
          <div class="flex align-items-center gap-2">
            <p-button
              icon="pi pi-pencil"
              severity="warn"
              rounded
              [text]="true"
              styleClass="p-button-sm"
              (click)="edit(r)"
            ></p-button>

            <p-button
              icon="pi pi-trash"
              severity="danger"
              rounded
              [text]="true"
              styleClass="p-button-sm"
              (click)="remove(i)"
            ></p-button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <ng-template pTemplate="footer">
    <p-button label="Close" class="p-button-text" (click)="close()" />
  </ng-template>
</p-dialog>
